// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRecordTaxYearChangeResponseDto
 */
export interface IRecordTaxYearChangeResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IRecordTaxYearChangeResponseDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IRecordTaxYearChangeResponseDto
     */
    record_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRecordTaxYearChangeResponseDto
     */
    status?: IRecordTaxYearChangeResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IRecordTaxYearChangeResponseDto
     */
    status_details?: string;
}

/**
* @export
* @enum {string}
*/
export enum IRecordTaxYearChangeResponseDtoStatusEnum {
    IN_PROGRESS = 'IN_PROGRESS',
    DONE = 'DONE',
    FAILED = 'FAILED'
}


/**
 * Check if a given object implements the IRecordTaxYearChangeResponseDto interface.
 */
export function instanceOfIRecordTaxYearChangeResponseDto(value: object): value is IRecordTaxYearChangeResponseDto {
    return true;
}

export function IRecordTaxYearChangeResponseDtoFromJSON(json: any): IRecordTaxYearChangeResponseDto {
    return IRecordTaxYearChangeResponseDtoFromJSONTyped(json, false);
}

export function IRecordTaxYearChangeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRecordTaxYearChangeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'record_id': json['record_id'] == null ? undefined : json['record_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'status_details': json['status_details'] == null ? undefined : json['status_details'],
    };
}

export function IRecordTaxYearChangeResponseDtoToJSON(json: any): IRecordTaxYearChangeResponseDto {
    return IRecordTaxYearChangeResponseDtoToJSONTyped(json, false);
}

export function IRecordTaxYearChangeResponseDtoToJSONTyped(value?: IRecordTaxYearChangeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'record_id': value['record_id'],
        'status': value['status'],
        'status_details': value['status_details'],
    };
}

